export const getReadRate = (text?: string, wpm = 225): number => {
  if (!text) return 0;
  const words = text.split(/\s+/).filter((w) => w != "").length;
  return words / wpm;
};

export const getReadTime = (text?: string, wpm?: number): number => Math.ceil(getReadRate(text, wpm));
